/**
 * This script is an extension of the 'G' graphite.js object.
 * DEPENDENCIES:
 * 		Bootstrap
 * 		Popper.js
 * 		(optional) NProgress
 * 		(optional) summernote
 */
window.G = (function() {
	var G = window.G || {};
	
	// check for Bootstrap
	if(typeof $.fn.tooltip === 'undefined' || typeof $.fn.modal === 'undefined') {
		throw new Error('graphite.plugins.js needs Bootstrap.');
	}
	// check for bootbox
	if(typeof Swal === 'undefined') {
		throw new Error('graphite.plugins.js needs SweetAlert2.');
	}
	
	// check for Popper
	if(typeof Popper === 'undefined') {
		throw new Error('graphite.plugins.js needs Popper.js.');
	}
	
	if(typeof flatpickr === 'undefined') {
		throw new Error('graphite.plugins.js needs flatpickr.');
	}

	/**
	 * Shows a simple modal dialog with a title, message, and OK button only.
	 * If you want more functionality (redirect on OK, etc), check out G.confirm()
	 * 
	 * @param str title larger font title of modal
	 * @param str message paragraph under title
	 * @return void
	 */
	G.alert = function(title, message, type) {
		type = type || null;
		var confirmDialog = Swal.fire({
			type: type,
			title: title,
			html: message
		});
		$('[data-toggle="tooltip"]').tooltip();
		return confirmDialog;
	}

	/**
	 * Opens a simple confirmation modal with title, message, and OK / Cancel buttons.
	 * 'hrefOrCallback' can be a url to redirect to, or a javascript callback.
	 * 
	 * @param str title
	 * @param str message
	 * @param str|func hrefOrCallback url to redirect to or JavaScript function to run after successful confirmation
	 * @return 
	 */
	G.confirm = function(title, message) {
		return $.Deferred(function(deferred) {
			Swal.fire({
				title: title,
				html: message,
				type: 'question',
				showCancelButton: true,
				confirmButtonClass: 'btn-primary',
				cancelButtonClass: 'btn-danger',
			}).then(function(result) {
				if(result.value) {
					deferred.resolve();
				} else {
					deferred.reject();
				}
			});
			$('[data-toggle="tooltip"]').tooltip();
		});
	}

	/**
	 * Opens a modal that fakes a progress bar while stuff happens in the background. 
	 * This function returns an object with a .finish() function, which you must run to close the modal.
	 * 
	 * @param str title top text of modal
	 * @param str message bottom text of modal
	 * @param obj nProgressOptions options passed to NProgress object
	 * @return {finish: [Function]} object that you can call .finish() on to exit the dialog
	 */
	G.progress = function(title, message) {
		Swal.fire({
			title: title,
			html: message,
			allowOutsideClick: false,
			onBeforeOpen: function() {
				Swal.showLoading();
			}
		});
		$('[data-toggle="tooltip"]').tooltip();
		
		return function(title, message, duration) {
			Swal.close();
			if(title || message) {
				dialog = Swal.fire(title, message);
				if(duration !== undefined){
					window.setTimeout(function() {
						Swal.close();
					}, duration)
				}
			}
		}
	}

	/**
	 * General event hooks that need to happen when graphite.js is loaded
	 */
	G.eventHooks = function(){
		//Bootstrap Data API Initialization
		$('[data-toggle="popover"]').popover();
		$('[data-toggle="tooltip"]').tooltip();
		
		//gEditor Data API Initialization (summernote)
		var gHtmlEditors = $('[data-html-editor]:not(\'[data-html-editor-processed]\')');
		if(gHtmlEditors.length){
			$(gHtmlEditors).each(function(index, editor){
				var options = $(editor).attr('data-html-editor');
				var name = $(editor).attr('name');
				if(!options){
					options = {};	
				}else{
					options = JSON.parse(options);	
				}
				var input = $('<input type="hidden" name="'+name+'"/>').insertAfter(editor);
				
				options.callbacks = {
					onChange: function(contents){
						$(input).val(contents)
					}
				}
				// if there's already text in the editor, summernote won't update the input for us. so we do it here.
				if($(editor).is('textarea')){ // .html() will encode entities
					$(input).val($(editor).text());
				}else{ // div, etc
					$(input).val($(editor).html());
				}
				
				$(editor).attr('data-html-editor-processed', true);
				$(editor).summernote(options);
			});
		}
		
		//gDatePicker Data API Initialization
		var gDatePickers = $('[data-date-picker]:not(\'[data-date-picker-id]\')');
		$(gDatePickers).each(function(index, datepicker){
			G.buildDatePicker(datepicker);
		});
		
		//Widgets
		$('[data-g-widget]:not(\'.g-widget\')').each(function(index, element) {
			var widget = $(element).attr('data-g-widget');
			var options = $(element).attr('data-options');
			if(!options) {
				options = {};
			}else{
				options = JSON.parse(options);
			}
			$(element).addClass('g-widget');
			require(['/scripts/'+widget+'.widget.js'], function(widget) {
				widget.render(element, options);
			});
		});
	}
	
	var datepickers = [];

	G.datepicker = function(element, options){
		if($(element).attr('data-date-picker-id')) {
			return datepickers[$(element).attr('data-date-picker-id')];
		} else {
			G.buildDatePicker(element, options);
		}
	}

	G.buildDatePicker = function(datepicker, options) {
		var defaultOptions = {
			'dateFormat': 'F J, Y'
		}
		if(!options) {
			options = $(datepicker).attr('data-date-picker');
			options = JSON.parse(options || "{}");
		}
		options = Object.assign(defaultOptions, options);
		var id = datepickers.push($(datepicker).flatpickr(options))-1;
		$(datepicker).attr('data-date-picker-id', id);
		return datepickers[id];
	}

	$(function() {
		G.eventHooks();
	});
	
	return G;
})();